export default function NewWithdrawal() {
  return (
    <section className="sales-layout__page">
      <h1>Neue Entnahme</h1>
      <p>Die Funktion für neue Entnahmen ist in Vorbereitung.</p>
    </section>
  );
}
